<template lang="pug">
  v-container(fluid class="pa-0")
    v-layout(justify-center)
      v-flex(xs12)
        v-layout
          v-flex(xs12)
            Title(:titleName="item.name")
            UploadImages(
              @set-files="setFiles",
              :imageList="item.photos",
              :isEdit="true")
        v-divider(class="mb-6")
        v-layout
          v-flex(xs12)
            v-text-field(
              v-model="item.name"
              label="Название"
              outlined
              dense)
            v-textarea(
              v-model="item.description"
              label="Описание компании"
              outlined
              dense)
        v-row(justify="center" class="mb-10")
          v-btn(large outlined width="200" class="mr-6" style="border-color:#c7c7c7", @click="onCancel") Отмена
          v-btn(large width="200" color="#07f" dark, @click="editCompany", :loading="loading") Сохранить
</template>
<script>
export default {
  components: {
    Title: () => import('../../components/Adverts/AddNew/Title'),
    UploadImages: () => import('../../components/common/UploadImages')
  },
  props: {
    company: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    item: {},
    images: [],
    loading: false
  }),
  watch: {
    company(value) {
      this.item = { ...value }
    }
  },
  methods: {
    setFiles(images) {
      this.images = images
    },
    createFormData(companyId) {
      const media = new FormData()
      media.append('id', companyId)
      this.images.map(item => {
        media.append('images', item.file)
      })
      return media
    },
    async uploadImages() {
      const formData = await this.createFormData(this.company.companyId)
      return this.$store.dispatch('UPLOAD_IMAGES', formData)
    },
    async editCompany() {
      this.loading = true
      const data = {
        companyId: this.item.companyId,
        name: this.item.name,
        description: this.item.description
      }

      const uploadResult = await this.uploadImages()
      if (uploadResult.error) {
        const photos = Object.keys(this.company.photos).map(
          index => this.company.photos[index]
        )
        const restoreCompany = { ...Object.assign({}, this.company), photos }
        this.$store.commit('SET_COMPANY_ITEM', restoreCompany)
        this.loading = false
        return
      }

      data.photos = uploadResult.images
      const prevImages = this.images.filter(item => item.file === null)
      if (prevImages.length) {
        prevImages.map(item => {
          data.photos.push(item.src)
        })
      }

      const setCompanyResponse = await this.$store.dispatch('SET_COMPANY', data)
      console.log('setCompanyResponse: ', setCompanyResponse)
      if (setCompanyResponse.error) {
        alert(
          setCompanyResponse.msg ||
            'Произощла ошибка. Обратитесь к администратору.'
        )
        this.loading = false
        return
      }
      await this.$router.push({ path: '/company/list' })
      this.loading = false
    },
    onCancel() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
